import styled from "styled-components";

export const BulkSectionDivider = styled.hr`
    border: none;
    border-top: 1px solid #dbe5ed;
    margin: 1.2rem -1.5rem 1rem;
`;
export const BulkSectionHeader = styled.div`
    margin-bottom: 1rem;
`;

export const BulkSectionTitle = styled.h2`
    color: #8E4EB4;
    font: normal normal bold 18px/21px Manrope;
`;

export const BulkSectionDescription = styled.p`
    color: #4b5155;
    font-size: 0.875rem;
    line-height: 1.5;
    margin: 0;
`;

export const DefaultPermissionToggle = styled.label`
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: space-between;
    width: 100%;
    max-width: 34rem;
    box-sizing: border-box;
    margin-top: 1rem;
    padding: 0.75rem 1rem;
    border: 1px solid #8796b9;
    border-radius: 0.75rem;
    box-shadow: 0 3px 6px #00000029;
    font-size: 0.875rem;
    font-weight: 700;

    > span:first-child { flex: 1; }
    > span:last-child { flex-shrink: 0; }
`;

export const DefaultPermissionToggleHint = styled.span`
    color: #8796b9;
    white-space: nowrap;
    @media (max-width: 480px) { display: none; }
`;
